<template>
    <v-container class="past-event p-0" fluid>
        <vue-headful :title="$t('past_event.title') + $t('title')"></vue-headful>
        <HkiaraceBannerFrame :src="require('../../../assets/memorable-moments.png')"
                             :label="$t('past_event.title')">
            <div v-infinite-scroll="loadMore"
                 :infinite-scroll-distance="500"
                 :infinite-scroll-throttle-delay="1000"
                 :infinite-scroll-disabled="loading || !moreEvents">
                <v-row class="m-0">
                    <v-col cols="12" md="4" sm="6"
                           class="past-event-cell"
                           v-for="event in events"
                           :key="event.id"
                           @click="showEventDetail(event)">
                        <v-row class="past-event-content-wrapper fill-height">
                            <v-col>
                                <v-row no-gutters>
                                    <v-col class="past-event-img-wrapper" :style="getPastEventImgStyle(event)">

                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col class="past-event-detail title-font">
                                        <div class="past-event-category">
                                            {{event.category.name}}
                                        </div>
                                        <div class="past-event-name" v-html="event.name"></div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </HkiaraceBannerFrame>
    </v-container>
</template>

<script>
    import _ from 'lodash';
    import {HOST} from '../../../main';
    import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";

    var infiniteScroll = require('vue-infinite-scroll');

    export default {
        name: 'PastEvent',
        directives: {infiniteScroll},
        components: {HkiaraceBannerFrame},
        data() {
            return {
                pageSize: 6,
                pageNo: 0,
                loading: false,
                events: [],
                moreEvents: true,
            };
        },
        mounted() {

        },
        methods: {
            loadMore() {
                if (!this.loading && this.moreEvents) {
                    this.loading = true;
                    this.$callAPI('hkiarace/event/past/', {page_size: this.pageSize, page_no: this.pageNo}, function (response) {
                        if (response.body.events.length === 0) {
                            this.moreEvents = false;
                        } else {
                            this.events = _.concat(this.events, response.body.events);
                            this.pageNo += 1;
                        }

                        this.loading = false;
                    }, null, true);
                }
            },
            getPastEventImgStyle(event) {
                return {
                    'background-image': `url("${HOST}static/` + (event.memorable_moment_cover_id ? event.memorable_moment_cover_id : JSON.parse(event.images)[0]) + '")',
                }
            },
            getURL(f) {
                if (f instanceof File) {
                    return URL.createObjectURL(f);
                } else {
                    return 'api/static/' + f;
                }
            },
            getEventStyle(event) {
                return {
                    'background-image': `url("${HOST}static/` + (event.memorable_moment_cover_id ? event.memorable_moment_cover_id : JSON.parse(event.images)[0]) + '")',
                    'background-size': 'cover',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat'
                }
            },
            getCategoryStyle(event) {
                let category = event.category;

                return {
                    "background-color": category.color,
                };
            },
            showEventDetail(event) {
                this.$router.push({name: 'past-event-detail', params: {eventId: event.id}})
            },
        },
    }
</script>

<style lang="less">
    .past-event {
        .past-event-cell {
            text-align: left;
            padding: 1rem;

            .past-event-content-wrapper {
                background-color: white;

                .past-event-img-wrapper {
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                }

                .past-event-detail {
                    padding: 0.5rem;

                    .past-event-category {
                        font-size: 0.9rem;
                        color: rgba(105, 103, 103, 0.8);
                        line-height: 2em;

                        @media only screen and (max-width: 1200px) {
                            font-size: 0.8rem;
                        }
                    }

                    .past-event-name {
                        font-size: 2rem;
                        line-height: 1.2em;
                        margin: 0;

                        @media only screen and (max-width: 1200px) {
                            font-size: 1.5rem;
                        }
                    }
                }
            }


        }
    }
</style>
